export default __webpack_public_path__ + "static/media/Managed-Services_Bg-Loop.6dc121d0.mp4";